// extracted by mini-css-extract-plugin
module.exports = {"main":"AnimalEventMarker_main__2K6rM","selected":"AnimalEventMarker_selected__f2TgG"};